import { render, staticRenderFns } from "./Year01.vue?vue&type=template&id=9ec301aa&scoped=true&"
import script from "./Year01.vue?vue&type=script&lang=js&"
export * from "./Year01.vue?vue&type=script&lang=js&"
import style0 from "./Year01.vue?vue&type=style&index=0&id=9ec301aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec301aa",
  null
  
)

export default component.exports